import { useCartContext } from "../context/CartContext";

export function useCart() {
  const { items, dispatch } = useCartContext();

  const totalCount = items.reduce((sum, item) => sum + item.quantity, 0);

  const totalPrice = items.reduce((sum, item) => {
    const price = item.salePrice !== null ? item.salePrice : item.price;
    return sum + price * item.quantity;
  }, 0);

  function addItem(product, quantity = 1) {
    dispatch({ type: "ADD_ITEM", product, quantity });
  }

  function updateQuantity(productId, quantity) {
    dispatch({ type: "UPDATE_QUANTITY", productId, quantity });
  }

  function removeItem(productId) {
    dispatch({ type: "REMOVE_ITEM", productId });
  }

  function clearCart() {
    dispatch({ type: "CLEAR" });
  }

  function isInCart(productId) {
    return items.some(item => item.productId === productId);
  }

  return {
    items,
    totalCount,
    totalPrice,
    addItem,
    updateQuantity,
    removeItem,
    clearCart,
    isInCart,
  };
}
